import React from 'react';
import gql from 'graphql-tag';

import SimilarListingsRow from './discovery/similar_listings_row';
import {
  Item2EndedListingData,
  SimilarListingsFields,
} from '../schemas/rql';
import RecommendedShopsRow from './recommended_shops_row';

import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import {
  showItemPageListingFlags,
  showShopRow,
  localizedSimilarListingsTitle,
} from '@reverbdotcom/commons/src/localize_listing_rows_utils';

export const Item2EndedListingFragment = gql`
  fragment Item2EndedListingData on Listing {
    _id
    id
    state
  }
`;

interface IProps {
  listing: Item2EndedListingData.Fragment;
  similarListings: SimilarListingsFields.Fragment[];
  userIsBuyer: boolean;
  userIsSeller: boolean;
}

export function unqualifiedToRenderEndedListingRow(
  listing: Item2EndedListingData.Fragment,
  userIsBuyer: boolean,
  userIsSeller: boolean,
): boolean {
  if (!listing) {
    return null;
  }

  const unqualifiedStates = ['live', 'draft'];

  return (
    [
      unqualifiedStates.includes(listing.state),
      userIsBuyer,
      userIsSeller,
    ].some(Boolean)
  );
}

export function Item2EndedListingRow(props: IProps) {
  const { listing, userIsBuyer, userIsSeller, similarListings } = props;
  const user = useUser();

  if (
    unqualifiedToRenderEndedListingRow(
      listing,
      userIsBuyer,
      userIsSeller,
    )
  ) {
    return null;
  }

  return (
    <div className="scaling-mb-3">
      {showShopRow(user) &&
        <RecommendedShopsRow
          listing={listing}
        />
      }
      <SimilarListingsRow
        similarListings={similarListings}
        title={localizedSimilarListingsTitle(user)}
        eventName={MParticleEventName.ViewedItemEndedHeaderSimilarListings}
        showFlags={showItemPageListingFlags(user)}
        largeTiles
        displayAddToCart
      />
    </div>
  );
}

export default Item2EndedListingRow;
